export const iconFontAwesomeClothingFashionHatCowboy = (
	<i className="fa-solid fa-hat-cowboy"></i>
);
